import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/4c40415a-01e8-4409-9385-edc3738c9664";
export const REGISTER_URL = "https://a.ntrk2.com/9b1a2635-1310-4b98-ac95-51840557c3d8";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://hitphwin.kzw2a.com/download?id=3ubni2rb8lds305";

export * from "./codes";
export * from "./context";
